import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getStudiesByStudentId } from "../../services/StudyService";
import { ToastContainer } from "react-toastify";

export const StudentStudy = () => {
  const [studies, setStudies] = useState([]);
  const { id } = useParams();
  const navigator = useNavigate();

  useEffect(() => {
    const fetchStudies = async () => {
      try {
        const response = await getStudiesByStudentId(id);
        setStudies(response.data);
      } catch (error) {
        console.error("Failed to fetch studies", error);
      }
    };

    fetchStudies();
  }, [id]);

  const getYearsOfStudy = (startDateStr, finishDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(finishDateStr);

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    let result = `${years} year${years !== 1 ? "s" : ""}`;
    if (months > 0) {
      result += `, ${months} month${months !== 1 ? "s" : ""}`;
    }

    return result;
  };

  const viewMore = (id) => navigator(`/admin/viewProgress/${id}`);

  return (
    <>
      <ToastContainer />
      <div className="card-body">
        <div className="d-flex mb-4">
          <h5 className="mb-3">📚 Study details</h5>
        </div>
        {studies.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Level</th>
                  <th>University</th>
                  <th>Country</th>
                  <th>Years of Study</th>
                  <th>Satrt Date</th>
                  <th>Finish Date</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {studies.map((study, index) => (
                  <tr key={study.studyId}>
                    <td>{index + 1}</td>
                    <td>{study.level}</td>
                    <td>{study.univeristyName}</td>
                    <td>{study.country}</td>
                    <td>
                      {getYearsOfStudy(
                        new Date(study.startDate).toLocaleDateString(),
                        new Date(study.finishDate).toLocaleDateString()
                      )}
                    </td>
                    <td>{new Date(study.startDate).toLocaleDateString()}</td>
                    <td>{new Date(study.finishDate).toLocaleDateString()}</td>
                    <td
                      className="text-center fs-5 text-primary zis-ponter"
                      title="View study progress"
                      onClick={() => viewMore(study.studyId)}
                    >
                      <span className="fa fa-eye"></span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No studies found for this student.</p>
        )}
      </div>
    </>
  );
};
